import {
  Button,
  CarouselProductVariants,
  CarouselSectionTypes,
  CarouselTiledCards,
  ProductCarouselSlide,
} from '@dfh-corp-sites/ui'
import React from 'react'

import { useResultWithLeftEffect } from '../../../hooks/useResultWithLeftEffect'
import useRetailPrices from '../../../hooks/useRetailPrices'
import { useTestKitPrice } from '../../../hooks/useTestKitPrice'
import { useDispensaryContext } from '../../../lib/dispensaries'
import { buildCarouselSlideProductData } from '../../../lib/products/carousel'
import { useFeaturedProducts } from '../../../lib/sanity-dispensaries/featured-products'
import { constNull } from '../../../utils/constant'
import { pluckData } from '../../../utils/result'
import Link from '../../global/Link'

const FeaturedProducts: React.FC = () => {
  const dispensaryContext = useDispensaryContext()
  const dispensarySlug = dispensaryContext?.slug || ''

  const [, data] = useResultWithLeftEffect(useFeaturedProducts(), pluckData, constNull)
  const { shouldDisplayRetailPrice } = useRetailPrices()
  const { shouldShowTestKitPrice } = useTestKitPrice()

  if (!data || data.products.length === 0) {
    return null
  }

  const { products: featuredProducts } = data

  const getPath = (path: string) => {
    const isDispensary = !!dispensaryContext
    return isDispensary ? `/u/${dispensarySlug}${path}` : path
  }

  const slides = featuredProducts.map(
    (product): ProductCarouselSlide => ({
      _key: product.id,
      type: CarouselSectionTypes.Product,
      productData: buildCarouselSlideProductData({
        analyticsEventAppContext: 'dispensary_featured_products',
        product,
        showPrice: shouldShowTestKitPrice(product.sku),
        showRetailPrice: shouldDisplayRetailPrice,
      }),
    }),
  )

  return (
    <CarouselTiledCards
      title="Our favorite Designs for Health products"
      subtitle="featured products"
      slides={slides}
      sliderType={CarouselSectionTypes.Product}
      productVariant={CarouselProductVariants.Light}
      ctas={[
        <Button key="shop-all" asChild>
          <Link to={getPath('/products')}>Shop all products</Link>
        </Button>,
      ]}
    />
  )
}

export { FeaturedProducts }
